<template>
    <div id="selectCourse">
        <!--学科选择框-->
        <el-select v-model="subject_model" placeholder="请选择学科" size="small" clearable @change="select_subject">
            <el-option
                    v-for="(item,index) in subject_option"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
        <!--年级选择框-->
        <el-select v-model="grad_model" v-if="subject_model!=''" placeholder="请选择年级" size="small" clearable  @change="select_grad">
            <el-option
                    v-for="(item,index) in grad_option"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
        <!--年级章节-->
        <el-select v-model="section_model" v-if="grad_model!=''" placeholder="请选择章节" size="small" clearable  @change="select_section">
            <el-option
                    v-for="(item,index) in section_option"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
        <!--年级课程-->
        <el-select v-model="course_model"  v-if="section_model!=''" placeholder="请选择课程" size="small" clearable  @change="select_course">
            <el-option
                    v-for="(item,index) in course_option"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    import {getSubject,getGrad,getSection,getCourse} from '@/api/commonApi.js'
    export default {
        name: "selectCourse",
        props:{
            clickType:{

            },
            isSave:{
                type:Boolean,
                default(){
                    return false
                }
            },
        },
        data(){
          return{
              //选择框
              subject_model:sessionStorage.getItem('root_subject')||'',//学科选择
              subject_option:[],//学科选择--option
              grad_model:sessionStorage.getItem('second_subject')||'',//年级选择
              grad_option:[],//年级选择--option
              section_model:sessionStorage.getItem('third_subject')||'',//章节选择
              section_option:[],//章节选择--option
              course_model:sessionStorage.getItem('course')||'',//课程选择
              course_option:[],//课程选择--option
          }
        },
        methods:{
            //获取学科信息
            getSubject(){
                let _this= this;
                getSubject().then((res)=>{
                    if(res.errCode==0){
                        _this.subject_option = _.cloneDeep(res.data) ;
                        // if(_this.clickType==2){
                        //     _this.subject_option.unshift({
                        //         id: null,
                        //         name: "全部"
                        //     })
                        // }
                    }
                }).catch((err)=>{console.log(err)})
            },
            //获取年级信息
            getGrad(){
                let _this= this;
                let data = {
                    root_subject_id:this.subject_model
                }
                getGrad(data).then((res)=>{
                    if(res.errCode==0){
                        _this.grad_option = _.cloneDeep(res.data.subjects) ;
                        // if(_this.clickType==2){
                        //     _this.grad_option.unshift({
                        //         id: null,
                        //         name: "全部"
                        //     })
                        // }
                    }
                }).catch((err)=>{console.log(err)})
            },
            //获取章节信息
            getsection(){
                let _this= this;
                // _this.course_model='';//课程选择重置
                // _this.course_option=[];//课程选择--option重置
                let data = {
                    second_subject_id:this.grad_model
                }
                getSection(data).then((res)=>{
                    if(res.errCode==0){
                        _this.section_option = _.cloneDeep(res.data.subjects) ;
                        // if(_this.clickType==2){
                        //     _this.section_option.unshift({
                        //         id: null,
                        //         name: "全部"
                        //     })
                        // }

                    }
                }).catch((err)=>{console.log(err)})
            },
            //获取课程信息
            getCourse(){
                let _this= this;
                let data = {
                    third_subject_id:this.section_model
                }
                getCourse(data).then((res)=>{
                    if(res.errCode==0){
                        _this.course_option = _.cloneDeep(res.data.subjects) ;
                        // if(_this.clickType==2){
                        //     _this.course_option.unshift({
                        //         id: null,
                        //         name: "全部"
                        //     });
                        // }
                        //有课程的情况下
                        if(sessionStorage.getItem('course')!=''){
                            _this.course_option.forEach((item)=>{
                                if(item.id == _this.course_model){
                                    // _this.$emit('selectCourse', item);
                                    _this.$emit('selectCourse', {
                                        root_subject_id:this.subject_model,
                                        second_subject_id:this.grad_model,
                                        third_subject_id:this.section_model,
                                        subject_id:item,
                                    });
                                }
                            })
                        }
                        else{
                            _this.course_model = _this.course_option[0].id;
                            // _this.$emit('selectCourse', _this.course_option[0]);
                            _this.$emit('selectCourse', {
                                root_subject_id:this.subject_model,
                                second_subject_id:this.grad_model,
                                third_subject_id:this.section_model,
                                subject_id:_this.course_option[0],
                            },true);
                        }
                    }
                }).catch((err)=>{console.log(err)})
            },
            //选择学科
            select_subject(val){
                console.log(this.subject_model,5656565)
                this.grad_model='';//年级选择重置
                this.grad_option=[];//年级选择--option重置
                this.section_model='';//章节选择重置
                this.section_option=[];//章节选择--option重置
                this.course_model='';//课程选择重置
                this.course_option=[];//课程选择--option重置
                // this.$emit('selectCourse',{});
                this.$emit('selectCourse', {
                    root_subject_id:this.subject_model,
                    second_subject_id:'',
                    third_subject_id:'',
                    subject_id:'',
                });
                this.getGrad();
            },
            // 选择年级
            select_grad(val){
                this.section_model='';//章节选择重置
                this.section_option=[];//章节选择--option重置
                this.course_model='';//课程选择重置
                this.course_option=[];//课程选择--option重置
                // this.$emit('selectCourse',{});
                this.$emit('selectCourse', {
                    root_subject_id:this.subject_model,
                    second_subject_id:this.grad_model,
                    third_subject_id:'',
                    subject_id:'',
                });
                this.getsection();
            },
            //选择章节
            select_section(val){
                this.course_model='';//课程选择重置
                this.course_option=[];//课程选择--option重置
                // this.$emit('selectCourse',{});
                this.$emit('selectCourse', {
                    root_subject_id:this.subject_model,
                    second_subject_id:this.grad_model,
                    third_subject_id:this.section_model,
                    subject_id:'',
                });
                this.getCourse();
            },
            // 选择课程
            select_course(val){
                if(val){
                    this.course_option.forEach((item)=>{
                        if(item.id==val){
                            // this.$emit('selectCourse',item);
                            this.$emit('selectCourse', {
                                root_subject_id:this.subject_model,
                                second_subject_id:this.grad_model,
                                third_subject_id:this.section_model,
                                subject_id:item,
                            });
                        }
                    })
                }else{
                    this.$emit('selectCourse', {
                        root_subject_id:this.subject_model,
                        second_subject_id:this.grad_model,
                        third_subject_id:this.section_model,
                        subject_id:'',
                    });
                }

            },
        },
        created(){
            // this.subject_model='';//学科选择
            // this.subject_option=[];//学科选择--option
            // this.grad_model='';//年级选择重置
            // this.grad_option=[];//年级选择--option重置
            // this.section_model='';//章节选择重置
            // this.section_option=[];//章节选择--option重置
            // this.course_model='';//课程选择重置
            // this.course_option=[];//课程选择--option重置
            this.getSubject();
            if(this.isSave){
                this.subject_model = '' ;
                this.grad_model = '' ;
                this.section_model = '' ;
                this.course_model = '' ;
            }
            if(this.subject_model!='' && !this.isSave){
                this.getGrad();
                this.getsection();
                this.getCourse();
                // console.log()
                // this.$emit('selectCourse',this.course_model);

                // console.log(this.course_model,sessionStorage.getItem('course'))
            }
        },
    }
</script>

<style scoped lang="scss">
#selectCourse{
    width: calc(100% - 1.2rem);
    display:inline-block;
    .el-select{
        margin-right:0.1rem;
        width: 23%;
        min-width:1rem;
        &:last-of-type{
             margin:0;
         }
    }
}
</style>
